import React from 'react';

const Footer = () => {

    return (
        <div className='footer-bg' style={{ borderTop: "1px solid green" }}>
            <div className="py-5 px-5 text-light">
                <p>Copyright ©Rimon-Webfolio-2022 | This website is made by Imam Hassan Rimon</p>
            </div>
        </div>
    );
};

export default Footer;